var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-chat__wrapper"},_vm._l((_vm.messages),function(message){return _c('e-chat-message',{key:message.id,attrs:{"subject":message.subject,"type":message.type,"id":message.id,"message":message.message}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-632b8efa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/chat/chat.vue
// module id = VMNc
// module chunks = 22